import { calculatePolygonArea } from '@/editor/model/polygon/utils';
import { IWallEdge } from '@/editor/types';
import { dispersePath } from '../shape';
import { getPathFromEdges } from '../edge';

export function getAreaInfo(area: { corePathInfos: IWallEdge[]; coreHoleInfos: IWallEdge[][] }) {
  const path = dispersePath(getPathFromEdges(area.corePathInfos));
  const holes = area.coreHoleInfos.map((holes) => dispersePath(getPathFromEdges(holes)));

  let coreArea = Math.abs(calculatePolygonArea(path));
  holes.forEach((hole) => (coreArea -= Math.abs(calculatePolygonArea(hole))));

  return {
    innerArea: 0,
    coreArea: Number((coreArea / (1000 * 1000)).toFixed(2))
  };
}
